// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const FooterSocialLinkedIn: React.FC<{ size?: number; color1?: string; className?: string }> = ({
    size = 24,
    className,
}) => (
    <svg className={className} focusable="false" viewBox="0 0 24 24" width={size} height={size}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0M8.686 9.988H6.198V18h2.488zm6.333-.2c-1.21 0-2.022.663-2.354 1.293h-.034V9.988h-2.387V18h2.486v-3.967c0-1.045.198-2.055 1.491-2.055 1.275 0 1.294 1.192 1.294 2.122V18H18v-4.401c0-2.154-.463-3.812-2.98-3.812M8.161 6.192A1.44 1.44 0 0 0 6 7.44c0 .795.645 1.454 1.44 1.454.796 0 1.442-.659 1.442-1.454 0-.515-.275-.99-.72-1.248"
        />
    </svg>
);

export default React.memo(FooterSocialLinkedIn);
